module.exports = __webpack_public_path__ + "img/product_42.401fb02.webp";